import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ReorderService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ServiceplanComponent } from './serviceplan.component';
import { ServiceplanRoutingModule } from './serviceplan-routing.module';
import { ServiceplanFormModule } from '../serviceplan-form/serviceplan-form.module';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EventsModule } from '../events/events.module';
@NgModule({
  declarations: [
    ServiceplanComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ServiceplanRoutingModule,
    NgSelectModule,
    ServiceplanFormModule,
    PDFExportModule,
    EventsModule,
  ],
  exports:[ServiceplanComponent],
  providers: [ReorderService ]
})
export class ServiceplanModule { }
